export default {
  namespaced: true,
  vxg_master_account: {
    title: "master account",
    name: "Name",
    description: "Description",
    api_server: "Api server",
    api_user: "API user",
    api_password: "API password",
    api_key: "Api key",
    server_video: "Video server",
    export_service_url: "Export service URL",
    source_url: "Source url",
    number_cameras: "Number of cameras",
    record_type: "Record type",
    url: "Api server url",
  },
};
